import API from "../api";

export const getInfoEvent = (course_id) => {
    return API.get(`/api/info_next_event/${course_id}`);
};
